import { render, staticRenderFns } from "./DistributorDetails.vue?vue&type=template&id=ef2923de&scoped=true"
import script from "./DistributorDetails.vue?vue&type=script&lang=js"
export * from "./DistributorDetails.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./DistributorDetails.vue?vue&type=style&index=0&id=ef2923de&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ef2923de",
  "5bba5a28"
  
)

export default component.exports